<template>
  <div class="promotion-content-container">
    <div class="drawer-outside-wrapper"
         @click="drawerOutsideClicked">
      <!--顶部导航-->
      <nav-header></nav-header>

      <!--用户信息-->
      <promotion-header @view-shortcut="handleViewKeyBoardModal"></promotion-header>

      <!--过滤面板-->
      <filter-panel
          ref="filter-panel"
          :is-show-user-guide="isShowUserGuide"></filter-panel>

      <div class="table-content-container ad-p">
        <!--标签页-->
        <tabs-list :tabs="tabs.PromotionTypes"
                   :onChangeActiveTab="onChangeActiveTab"
                   :activeIndex="activeTabIndex">
        </tabs-list>

        <div class="promotion-card">
          <!--路由区域-->
          <router-view ref="ad" v-if="showRouteView" :isSupportForbidden="isSupportForbidden"></router-view>

          <!--底栏-->
          <div class="promotion-footer">
            <div class="pagination-wrapper" v-show="pagination.totalNum !== 0">
              <div class="ad-m-r-md">{{ $bp_t(`共${pagination.totalNum}条记录`, 'common.common_bar_record', {data: pagination.totalNum}) }}</div>
              <byted-select
                      class="page-size-select"
                      transfer
                      size="sm"
                      v-model="pagination.pageSize"
                      @change="onClickChangePageSize">
                <byted-option :value="10">{{ $bp_t('10/页', 'common.pagesize', {data: 10}) }}</byted-option>
                <byted-option :value="20">{{ $bp_t('20/页', 'common.pagesize', {data: 20}) }}</byted-option>
                <byted-option :value="50">{{ $bp_t('50/页', 'common.pagesize', {data: 50}) }}</byted-option>
                <byted-option :value="100">{{ $bp_t('100/页', 'common.pagesize', {data: 100}) }}</byted-option>
              </byted-select>
              <byted-pagination
                      class="ad-m-l-md"
                      size="sm"
                      show-quick-jumper
                      :page-size="pagination.pageSize"
                      :total="pagination.totalNum"
                      :current-page="pagination.curPage"
                      @page-change="onPageChange"></byted-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 侧弹窗 -->
    <byted-drawer
      v-model="showRightDrawer"
      placement="right"
      id="promotion-drawer-container"
      :closable="false"
      :mask-closable="false"
      :maskable="false"
      :width="drawerWidth"
      :drawer-style="drawerStyle">
      <promotion-drawer
        v-if="showRightDrawer"
        :cur-tab-name="curTabName"
        @drawerClose="drawerClosed"></promotion-drawer>
    </byted-drawer>

    <account-tree :drawer-style="drawerStyle"></account-tree>

    <!-- 点击审核建议，出现弹窗 -->
    <div class="toggle-btn-wrapper"
         v-if="showToggleBtn"
         @click="showAuditDrawer = true">
      <span>审核建议</span>
      <byted-icon color="#fff"
                  name="double-angle-left"></byted-icon>
    </div>
    <!-- 审核建议弹窗 -->
    <byted-drawer
      v-model="showAuditDrawer"
      placement="right"
      :closable="false"
      :mask-closable="false"
      :maskable="false"
      :width="740"
      :drawer-style="drawerStyle">
      <audit-drawer
        v-if="showAuditDrawer"
        :audit-drawer-data="auditDrawerData"
        @hide-drawer="showAuditDrawer = false"
        @on-click-edit="onClickEditAudit"/>
    </byted-drawer>

    <!-- 问卷功能下线，逻辑暂保留 -->
    <!-- <img src="../../static/images/bp_questionnaire.png"  -->
      <!-- class="promition-bp-questionnaire"  -->
      <!-- @click="bpQuestionnaireClick" -->
      <!-- v-if="bpQuestionnaireVisiable"/> -->
    <!--
    <new-feature-guide
      :modalConfig="featureKeyBoardModalConfig"
      :onConfirm="handleViewKeyBoardModal"
      confirmText="查看快捷键">
    </new-feature-guide>
    -->

    <promotion-keyboard-modal
      :modalVisible="keyboardModalVisible"
      :onCancel="handleCloseKeyBoardModal"
      ></promotion-keyboard-modal>
    <double-check-modal
      v-model="doubleCheckModalProps.isShow"
      v-bind="doubleCheckModalProps"
    />
    <!--    用户迁移模态框。 模态框不应该显示两个。 下面那个ios版本提示模态框不应该和本模态框共存。（为什么不把模态框抽出来啊...）  -->
    <user-migrate-modal
      :show="userMigrateModalShow"
      :disableKey=this.disableMigrateModalKey
      @closeMigrateModal="userMigrateModalShow = false">
    </user-migrate-modal>
  </div>
</template>
<script>
  import Apis from 'Src/const/apis'
  import NavHeader from 'Src/components/common/nav-header.vue'
  import PromotionHeader from 'Src/components/promotion/promotion-header.vue'
  import FilterPanel from 'Src/components/promotion/filter-panel.vue'
  import TabsList from 'Src/components/common/tabs-list.vue'
  // import PromotionDrawer from 'Src/components/promotion/promotion-drawer/promotion-drawer.vue'
  import { promotionPageSizeKey, setLocalStorageParam, deleteDrawerQueryParams, resetCustomScroll, getCurTabName, getCurQuery } from 'Src/pagelets/promotion/common.js'
  import AccountTree from 'Src/components/promotion/account-tree.vue'
  import 'Src/components/directives/click-outside.js'
  import 'Src/components/directives/listen-show-directive'
  import { landingType } from 'Src/const/state/campaign.js'
  import { catchableParse } from 'Src/util/json'
  import { loginType } from 'Src/const/state/ad'
  import qs from 'querystring'

  import { userGuideNewPromotion, userGuideHoverNewPromotion } from 'Src/const/user-guide-flow.js'
  import { promotionTriggerGuideConst, promotionTriggerGuideIndexMap, promotionTriggerGuideConf } from 'Src/const/promotion-trigger-guide-config.js'
  import { PromotionTypes, PromotionsPollingTaskName, AD_BATCH_TASK_STATUS, asyncTaskOperateDes } from 'Src/pagelets/promotion/promotion-state.js'
  import {
    PAGINATION_CHANGE,
    PAGE_CHANGE,
    PAGE_SIZE_CHANGE,
    SET_SELECTED_ROW_INDEX
  } from 'Src/pages/promotion/store.js'
  import Tool from 'Src/util/tool'
  // import AuditDrawer from 'Src/components/audit/audit-drawer/audit-drawer.vue'
  import { CreativeAuditTypes, AuditTypesValue } from '../../components/audit/audit-drawer/audit-const.js'
  import PromotionKeyBoardModal from 'Src/components/promotion/promotion-keyboard-modal.vue'
  import promotionShortcut from './support/promotion-shortcut.js'
  import DoubleCheckModal from 'Src/components/dialog/double-check-modal.vue'
  import { DEFAULT_DOUBLE_CHECK_BID_MODAL_PROPS } from 'Src/const/state/bid'
  import { Polling } from '../../util/polling'
  import { promotionTTIMonitor, PROMOTION_MOUNTED } from 'Src/util/perf-monitor/monitors'
  import json from 'Src/util/json.js'
  import '@webcomponents/custom-elements/custom-elements.min'
  import { Guide ,html} from "@ad/ad-darwin"
  import "@ad/ad-darwin/dist/style/darwin-venus.css"
  import IosLogo from 'Src/components/common/ios-logo.vue'
  import UserMigrateModal from 'Src/components/promotion/user-migrate-modal.vue'

  const asyncComponent = {
    'audit-drawer': (resolve) => require.ensure(
      [],
      require => {
        resolve(require('Src/components/audit/audit-drawer/audit-drawer.vue'))
      },
      () => {},
      'AuditDrawer'
    ),
    'promotion-drawer': resolve => require.ensure(
      [],
      require => {resolve(require('Src/components/promotion/promotion-drawer/promotion-drawer.vue'))},
      () => {},
      'promotion-drawer'
    )
  }
  const SkanImg = GET_IMG_BYTE_SRC('tos-cn-i-yvqzo4lhg5/db3002c535fb52b4bdb733d94c2d2f10.png~tplv-yvqzo4lhg5-image.image')
  const lang = document.documentElement.lang
  const LandingType = landingType

  export default {
    mixins: [promotionShortcut],
    components: {
      UserMigrateModal,
      [PromotionHeader.name]: PromotionHeader,
      [NavHeader.name]: NavHeader,
      [FilterPanel.name]: FilterPanel,
      [TabsList.name]: TabsList,
      [AccountTree.name]: AccountTree,
      [PromotionKeyBoardModal.name]: PromotionKeyBoardModal,
      [DoubleCheckModal.name]: DoubleCheckModal,
      [IosLogo.name]: IosLogo,
      ...asyncComponent
    },
    provide () {
      return {
        doubleCheckModalShouldShow: this.doubleCheckModalShouldShow,
        doubleCheckModalUpdateProps: this.doubleCheckModalUpdateProps
      }
    },
    data() {
      return {
        showAuditDrawer: false,
        showToggleBtn: false,
        tabs: {
          PromotionTypes
        },
        guideConfig: {
          switch: window.localStorage.getItem('guide-switch'),
          curDom: ''
        },
        showRightDrawer: false,
        isShowUserGuide: false,
        isHoverGuide: false,
        userGuideModalShow: false,
        userGuideNewPromotion: userGuideNewPromotion,
        userGuideHoverNewPromotion: userGuideHoverNewPromotion,
        showRouteView: true,
        // bpQuestionnaireVisiable: false,
        userGuideStartTime: 0,
        drawerTopOffset: 64,
        curPromotionTriggerGuideConf: [],
        promotionTriggerGuideIndexMap,
        // isCeiling: false,
        drawerWidth: 933,
        eventsAfterDrawerClosed: [],
        featureKeyBoardModalConfig: {
          id: 'featureKeyboard',
          bindElementId: 'keyboard-short-cut',
          url: require('Src/static/images/promotion-keyboard.svg'),
          title: '快捷键功能全新上线！',
          tip: '关键功能直接使用键盘操作，快速提升效率。'
        },
        keyboardModalVisible: false,
        // 出价警告弹窗属性
        doubleCheckModalProps: DEFAULT_DOUBLE_CHECK_BID_MODAL_PROPS,
        polling: {
          asyncTaskPolling: null
        },
        // 是否有ios14白名单
        isShowSkanGuide: false,
        isSKANAuth: false,
        skanRightLocal: 'ad-dedicate-type-guide',
        SkanGuide:null,
        userMigrateModalShow: false,
        iosWarnModalShow: false,
        disableMigrateModalKey: "disableMigrateModal_user_" + GLOBAL_VAR.coreUser.id // 二次上线的缓存名
      }
    },
    computed: {
      curTabName() {
        return this.$route.name || getCurTabName() // 推广管理四个 tab 改为异步组件后，在初始化时，不能在 router-view 外部依赖 this.$route 去读取当前路由信息，因为 tab 还未挂载时读取到的 this.$route.name 等值是空的
      },
      curQuery() {
        if (Object.keys(this.$route.query) > 0) {
          return this.$route.query
        }
        return getCurQuery()
      },
      drawerStyle() {
        // TODO 优化性能 throttle
        return {
          height: `calc(100% - ${this.drawerTopOffset}px)`,
          top: `${this.drawerTopOffset}px`,
        }
      },
      activeTabIndex() {
        const nameKey = this.curTabName || 'ad' // 推广管理四个 tab 改为异步组件后,虽然可以使用 this.$route.name,但是 tab 组件还未挂载时获取到的为 null，此时namekey 为 'ad'，当 tab 组件挂载完成后，this.$route.name 值发生改变，重新触发此逻辑，得到最后的 namekey，但如果前后 namekey 不一致，视觉上会有闪烁，所以这里不适用 this.$route.name
        // 广告主访问不支持的推广TAB，则默认为ad
        const tab = PromotionTypes[nameKey] || PromotionTypes.ad

        if(nameKey !== tab.router) {
          this.changeRouter({router: tab.router})
        }
        return tab.value
      },
      isShowRightDrawer () {
        return this.$store.state.isShowRightDrawer
      },
      pagination () {
        return this.$store.state.pagination
      },
      auditDrawerData () {
        return this.$store.state.auditDrawerData
      },
      isSupportForbidden () {
        // 品牌账号下的功能禁用
        if (+GLOBAL_VAR?.advertiser?.user_adv_role === 583) {
          return true
        }
        // 是否在商品推广写功能禁用范围内（非UG和跨境电商的鲁班账号）
        return json.catchableParse(GLOBAL_VAR.isEcAdvertiser) && !Tool.isSupported(GLOBAL_VAR.adver_func.ExemptUGCrossBorder)
      }
    },
    watch: {
      isShowSkanGuide (newVal, oldVal) {//监听是否展示ios引导
        if (newVal && !this.SkanGuide && this.iosWarnModalShow) {
          this.SkanGuide = new Guide({
            guideStoreKey: 'ad-dedicate-type-guide',
            guideType: 'modal',
            initShow: true,
            options: {
              showCloseIcon: false,
              extraClass:'ios-skan-guide-modal',
              steps: [
                {
                  title:html`
                  <div class="content-area ad-d-flex">
                    <img src="${SkanImg}">
                  </div>
                  `,
                  titleAlign: 'center',
                  content: html`
                    <div class="explain">
                      <div class="explain-title">
                        关于苹果公司的iOS 14.5 版本隐私政策调整须知
                      </div>
                      <div class="explain-content">
                        苹果公司在iOS14.5版本中要求App Store中的应用程序都必须按照AppTracking Transparency 的要求，在跟踪前需得到用户许可。<br/>
                        苹果公司向开发者提供了SKAdNetwork归因方案，您可按照苹果公司的要求进行SKAdNetwork（SKAN）方案的开发，同时在巨量引擎广告投放平台内选择iOS14.5及以上版本流量对应的投放方式进行计划的创建。
                      </div>
                      <div class="explain-tips ad-d-flex">
                        <div class="ios-logo-wrapper">
                          <div class="ios-logo ad-d-flex">
                            <img src="${GET_IMG_BYTE_SRC('tos-cn-i-yvqzo4lhg5/ed92588c90e3a4a9c0d1d53e133a7124.svg~tplv-yvqzo4lhg5-image.image')}" class="tips-img" />
                            <span class="ios-logo-text">iOS</span>
                          </div>
                          <span class="ios-logo-content">我们将使用该图标在您的广告列表中标记受影响的广告，以便您方便地选中它们。</span>
                        </div>
                      </div>
                    </div>
                  `,
                  buttons: [{
                    text: '我知道了',
                    onClick: (curPoptip) => {
                      curPoptip.hide()
                    }
                  }]
                }
              ]
            }
          })
        }
      },
      auditDrawerData (newVal, oldVal) {
        if (
          (newVal.adID || newVal.creativeID) ||
          // 计划tab下，搜索省心计划展示审核建议侧弹窗
          (this.activeTabIndex === PromotionTypes.ad.value && newVal.adGroupId)
        ) {
          this.showAuditDrawer = true
        }
      },
      isShowRightDrawer (newVal) {
        if(!newVal) {
          window.localStorage.setItem('currentPromotionRowContext', null)
        }
        this.showRightDrawer = newVal
      },
      '$route.name': function() {
        // 还原至初始翻页Vuex状态（业务逻辑：保留每页个数）
        this.$store.dispatch(PAGINATION_CHANGE, {
          page_size: this.$store.state.pagination.pageSize,
          total_count: 0,
          page: 1
        })
      },
      '$route.path' () {
        this.checkForUserGuide()
      },
      'pagination.pageSize': function(newVal, oldVal) {
        if (newVal !== oldVal) {
          let curPageData = JSON.parse(JSON.stringify(this.pagination))

          setLocalStorageParam(promotionPageSizeKey, curPageData.pageSize)
        }
      },
    },
    created() {
      this.initModalShow()
      this.getAdvSKANAuth()
    },
    mounted () {
      BUS.$on('promotion-after-drawer-closed', this.onPromotionAfterDrawerClosed)
      window.teaEventV1('promotion_index_open', () => ({
        refer: document.referrer,
        url: window.location.href
      }), 'page')
      window.teaEvent('promotion_visit', {
        advertiser_id: GLOBAL_VAR.advertiser.id,
        advertiser_name: GLOBAL_VAR.advertiser.name
      })

      // 承诺函弹窗
      // 账户密码登录
      if(!(catchableParse(GLOBAL_VAR.sales) || catchableParse(GLOBAL_VAR.user_jobbed))){
        new Guide({
          guideStoreKey: `service-agreement-guide_${GLOBAL_VAR.advertiser.id}`,
          guideType: 'modal',
          initShow: true,
          options: {
            showCloseIcon: false,
            steps: [
              {
                title: '巨量引擎数据推广服务协议更新通知',
                titleAlign: 'left',
                content: html`
                  <div class="explain">
                    <div class="explain-content">
                      基于《个人信息保护法》及相关要求，《<a href="https://ad.oceanengine.com/overture/account/agreement" target="_blank" style="color:#338aff;">巨量引擎数据推广服务协议</a>》及其附件
                      《<a href="https://lf3-cdn-tos.draftstatic.com/obj/ies-hotsoon-draft/account_center/196de44c-839a-4ce9-b7a9-ea4b7a04d607.html" style="color:#338aff;" target="_blank">个人信息保护承诺函</a>》进行了更新，请您仔细阅读，确认悉知并同意相关内容。
                    </div>
                  </div>
                `,
                buttons: [{
                  text: '我已阅读并同意',
                  
                  onClick: (curPoptip) => {
                    window.teaEvent('service_agreement_guide_click', {
                      advertiser_id: GLOBAL_VAR.advertiser.id,
                      time: new Date() / 1,
                      customer_id: GLOBAL_VAR.advertiser.customer_id
                    })
                    curPoptip.hide()
                  }
                }],
                buttonsAlign: 'right'
              }
            ]
          }
        })
      }

      // 问卷功能下线，逻辑暂保留
      // this.bpQuestionnaireInit()
      // 兼容上一版本引导工具的缓存字段
      this.$nextTick(() => {
        this.checkForUserGuide()
      })
      $(document).scroll(() => {
        let offset = 64 - $(document).scrollTop()
        this.drawerTopOffset = offset > 0 ? offset : 0
        // this.isCeiling = this.handleFiltersCeilingHandle()
      })
      this.updateDrawerWidth()

      this.addSticky()
      // 检查是否有需要轮询的任务，目前是计划下批量修改为异步操作的时候，需要轮询后端的操作结果，需要在推广管理整个页面生效
      this.checkPolling()
      promotionTTIMonitor.mark(PROMOTION_MOUNTED)
    },
    beforeDestroy () {
      BUS.$off('promotion-after-drawer-closed', this.onPromotionAfterDrawerClosed)
    },
    methods: {
      initModalShow() {
        this.userMigrateModalShow = GLOBAL_VAR.customerType == 51
          && GLOBAL_VAR.advertiser.role == 0
          && localStorage.getItem(this.disableMigrateModalKey) !== "true"

        this.iosWarnModalShow = !this.userMigrateModalShow
      },
      getAdvSKANAuth () {
        BUI.fetch({
          url: Apis.common.getAdvSKANAuth,
          success: ({ code, data, msg } = {}) => {
            GLOBAL_VAR.isSKANAuth = data.result
            if (code === 0 && data.result && window.localStorage.getItem(this.skanRightLocal) !== 'off') {
              this.isShowSkanGuide = true
            }
            else {
              this.isShowSkanGuide = false
            }
          }
        })
      },
      onPromotionAfterDrawerClosed (eventName, params) {
        this.eventsAfterDrawerClosed.push({
          eventName, params
        })
      },
      // 每次进入到推广管理页面需要检查是否需要启动轮询
      // ① Polling 实例会把之前存在 localstoreage 中的队列拿出来继续请求。只要创建了任务就会被推到 pending 队列中，并更新到 localstorage
      //  如果关闭了页面，下次进入页面会复用之前的队列剩余记录，防止任务遗漏以及多发请求
      checkPolling() {
        window.polling = {}
        window.polling.adBatchOperateAsyncTask = this.polling.adBatchOperateAsyncTask = new Polling({
          taskName: PromotionsPollingTaskName.AD_BATCH_UPDATE,
          advertiserID: GLOBAL_VAR.advertiser.id,
          limitReqCount: 8,
          resultPollingInterval: 2000,
          callback: (task, resp) => this.adBatchUpdatePollCal(task, resp),
          requestDefault: {
            method: 'get',
            url: Apis.toolbox.platform_tools.task_detail
          },
          goBackPendingQueue: (task, resp) => {
            const stat = resp.data.task_stat
            if (stat && stat.task_status === AD_BATCH_TASK_STATUS.DONE) {
              return false
            }
            return true
          },
          storage: {
            use: true
          }
        })
      },
      adBatchUpdatePollCal(task, resp) {
        const stat = resp.data && resp.data.task_stat || {}
        const successCount = stat.success_item_num || 0,
              failCount = stat.fail_item_num || 0
        if (stat.task_status !== AD_BATCH_TASK_STATUS.DONE) {
          return
        }
        // 关闭该任务创建时对应的 notification 弹窗卡片
        this.$notification.close(task.data.notificationId)
        let msg = '',
            type = ''
        // 部分成功，部分失败
        if (successCount > 0 && failCount > 0) {
          msg = $bp_t(`${successCount}个计划${asyncTaskOperateDes[task.data.batchType]}成功`, 'bp.promotion_index_n_plan_success', [successCount, asyncTaskOperateDes[task.data.batchType]]) + '，' + $bp_t(`${failCount}个计划${asyncTaskOperateDes[task.data.batchType]}失败`, 'bp.promotion_index_n_plan_failed', [failCount, asyncTaskOperateDes[task.data.batchType]])
          type = 'warning'
        // 全部成功
        } else if (successCount > 0) {
          msg = $bp_t(`${successCount}个计划${asyncTaskOperateDes[task.data.batchType]}成功`, 'bp.promotion_index_n_plan_success', [successCount, asyncTaskOperateDes[task.data.batchType]])
          type = 'success'
        // 全部失败
        } else if (failCount > 0) {
          msg = $bp_t(`${failCount}个计划${asyncTaskOperateDes[task.data.batchType]}失败`, 'bp.promotion_index_n_plan_failed', [failCount, asyncTaskOperateDes[task.data.batchType]])
          type = 'error'
        }
        // 由于之前有全局覆盖 byte-icon 的样式，导致这里的样式不正确，需要手动覆盖
        const iconMap = {
          'warning': {
            name: 'exclamation-circle',
            color: '#FFA900'
          },
          'success': {
            name: 'check-circle',
            color: '#6ABF40'
          },
          'error': {
            name: 'close-circle',
            color: '#F65656'
          }
        }
        const key = `${Date.now()}`
        this.$notification.open({
          duration: null,
          icon: (h) => {
            return <byted-icon name={iconMap[type].name} color={iconMap[type].color}/>
          },
          message: msg,
          description: (createElement) => {
            return $bp_t('', 'bp.promotion_go_task_center_result_close_promot') ? <i18n path="bp.promotion_go_task_center_result_close_promot">
              <a
                style="color: #2F88FF;cursor: pointer;text-decoration: none;"
                target="_blank"
                href={`/bp/tools/task-center.html?aadvid=${GLOBAL_VAR.advertiser.id}#/backgound_task`}
              >
                {$bp_t('任务中心', 'common.task_center')}
              </a>
              <span
                style="color: #2F88FF;cursor: pointer;"
                onClick={() => this.$notification.close(key)}
              >
                { $bp_t('隐藏', 'common.hide') }
              </span>
            </i18n> : <div>前往
              <a
                style="color: #2F88FF;cursor: pointer;text-decoration: none;"
                target="_blank"
                href={`/bp/tools/task-center.html?aadvid=${GLOBAL_VAR.advertiser.id}#/backgound_task/detail/${task.data.task_id}`}
              >任务中心</a>查看结果，点击
              <span
                style="color: #2F88FF;cursor: pointer;"
                onClick={() => this.$notification.close(key)}
              >隐藏</span>关闭提示
            </div>

          },
          key,
          type
        })
      },
      onClickEditAudit ({landingType, campaignID, adID, type}) {
        if (type === AuditTypesValue.advancedCreative) {
          const landingTypeIsStore = (landingType === LandingType.ADVERTISER_STORE.value)
          // 门店推广
          if (landingTypeIsStore) {
            window.open(this.globalUpdateQuery(Apis.page.editCreative(adID)))
            return
          } else {
            window.open(this.globalUpdateQuery(Apis.pageAds.editAD(campaignID, adID, landingType)))
            return
          }
        }

        if (CreativeAuditTypes.indexOf(type) >= 0) {
          window.open(this.globalUpdateQuery(Apis.pageAds.editCreative(adID)))
          this.modifyAuditTeaEvent('creative')
        } else {
          window.open(this.globalUpdateQuery(Apis.pageAds.editAD(campaignID, adID, landingType)))
          this.modifyAuditTeaEvent('ad')
        }
      },
      bpQuestionnaireInit() {
        // 每个浏览器只展示一次
        let data = localStorage.getItem('bp_promotion_questionnaire_0728')
        if(!data) {
          this.bpQuestionnaireVisiable = true
        }
      },
      bpQuestionnaireClick(){
        const { advertiser = {}, coreUser = {} } = window.GLOBAL_VAR
        const loginWay = this.getLoginWay()
        this.bpQuestionnaireVisiable = false
        localStorage.setItem('bp_promotion_questionnaire_0728', 1)
        window.open(`https://wj.toutiao.com/q/27959/8371v6mv/56ca/?${qs.stringify({
          adv_id: advertiser.id,
          user_id: coreUser.id,
          login_way: loginWay
        })}`)
      },
      // 登录方式
      getLoginWay () {
          // 账户密码登录
        if(catchableParse(GLOBAL_VAR.isAdmin)){
          return loginType.isAdmin
        }else if(catchableParse(GLOBAL_VAR.sales)){
          // 内部系统附身: 内部优化师
          return loginType.isStaff
        }else if(catchableParse(GLOBAL_VAR.user_jobbed)){
          // 外部系统附身: 代理商 + 账户管家附身
          return loginType.isCoreUser
        }else{
          return 0
        }
      },
      addSticky() {
        if (!Tool.cssSupport('position', 'sticky') && window.Stickyfill) {
          let elements = document.querySelectorAll('.sticky')
          window.Stickyfill.add(elements)
        }
      },
      // 设置不同语言drawer宽度
      updateDrawerWidth() {
        switch(lang) {
          case 'en':
            this.drawerWidth = 955;
            break;
        }
      },
      // handleFiltersCeilingHandle: _.throttle(() => {
      //   const filterEle = document.querySelector('.tabs-list')
      //   if (filterEle) {
      //     return filterEle.getBoundingClientRect().top <= (0 - filterEle.clientHeight)
      //   }
      //   return false
      // }, 50),
      // 检测用户是否需要新手引导
      checkForUserGuide () {
        // 推广管理-商务管理平台新手引导弹窗不展示
        window.localStorage.setItem('realise_bm_new_function', true)
      },
      changeRouter(tab){
        if (tab.router) {
          this.$router.push({
            name: tab.router,
            query: this.curQuery
          })
        }
      },
      onChangeActiveTab(tab){
        this.changeRouter(tab)

        this.switchTabTeaEvent(tab.router)
      },
      drawerOutsideClicked () {
        if (this.showRightDrawer) {
          // 侧弹关闭埋点
          window.teaEvent('promotion_drawer_closed', {
            referer_path: window.location.pathname + window.location.hash.split('?')[0],
            action_source: 'outside_clicked'
          })
          this.drawerClosed()
        }
      },
      drawerClosed () {
        this.$store.commit('isShowRightDrawerChange', false)
        deleteDrawerQueryParams.call(this)

        this.clearSelectedRowIndex()

        this.eventsAfterDrawerClosed.forEach(e => {
          BUS.$emit(e.eventName, e.params)
        })
        this.$refs.ad && this.$refs.ad.closeDiagnosisDetailsGuide && this.$refs.ad.closeDiagnosisDetailsGuide() // 关闭新手引导的弹窗
      },
      clearSelectedRowIndex () {
        this.$store.commit(SET_SELECTED_ROW_INDEX, undefined)
      },
      onClickChangePageSize (newSize) {
        this.$store.commit(PAGE_CHANGE, 1)
        this.$store.commit(PAGE_SIZE_CHANGE, newSize)

        if (newSize !== undefined) {
          window.teaEvent('promotion_col_row', {
            rowSize: newSize
          })
        }
      },
      onPageChange: _.debounce(function (val) {
        // 暴力点击页码时，数据会混乱，需要加上 debounce
        this.$store.commit(PAGE_CHANGE, val)
        resetCustomScroll()
      }, 500),
      reload () {
        this.showRouteView = false
        this.$nextTick(function () {
          this.showRouteView = true
        })
      },
      doubleCheckModalShouldShow () {
        return Boolean(this.doubleCheckModalProps.bidWarning || this.doubleCheckModalProps.deepBidWarning)
      },
      doubleCheckModalUpdateProps (newProps) {
        this.doubleCheckModalProps = Object.assign({}, this.doubleCheckModalProps, newProps)
      }
    }
  }
</script>
<style lang="scss">
  @import './promotion-variable.scss';

  $icon-size: 16px;
  $basic-height: 30px;

  $small-font-size: 12px;
  $basic-data-height: $small-font-size;
  $td-line-height: 18px;

  $color-lighter: #999;
  $color: #333;
  $disabled-color: #d6d6d6;
  $disabled-icon-color: $disabled-color;

  $table-header-height: 48px;
  $table-padding: 10px;
  $link-color: #2f88ff;

  $th-bg: #f8f9fa;
  $th-hover-bg: #E4E9ED;

  #promotion-drawer-container {
    .bui-drawer-wrapper {
      will-change: unset;
    }
  }

  /* Reset Style */
  ul {
    padding: 0;
    margin: 0;
  }
  li {
    list-style: none;
  }
  a {
    text-decoration: none;
  }
  #innerFrame {
    display: none; // 隐藏场景化帮助
  }
  .toggle-btn-wrapper {
    z-index: 996;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 100px;
    right: 0;
    width: 32px;
    height: 102px;
    background: #338AFF;
    font-size: 14px;
    line-height: 16px;
    color: #fff;
    padding: 8px;
    border-radius: 4px 0 0 4px;
    .byted-icon {
      margin-top: 4px;
    }
  }
  .promition-bp-questionnaire{
    position: fixed;
    top: 200px;
    right: 0;
    width: 48px;
    height: 48px;
    z-index: 999;
    cursor: pointer;
  }
  .promotion-popper-hover {
    max-width: 300px;
    .suggestion-popover-body {
      max-height: 238px;
      overflow-y: auto;
    }
  }
  .user-guide-modal {
    color: #333333;
    .bui-modal-title {
      font-weight:600;
      font-size: 16px;
      text-align: center;
      line-height:24px;
    }
    .content-area {
      height: 160px;
      margin: 40px 0;
      .info-area {
        width: 200px;
        margin: 0 32px;
        float: left;
        position: relative;
        .info-order {
          position: absolute;
          left: 32px;
          top: -8px;
          color:rgba(102,102,102,0.1);
          font-size:30px;
          font-weight:bold;
          line-height: 36px;
        }
        .info-image {
          position: relative;
          left: 50px;
          width: 100px;
          height: 100px;
          padding: 18px;
          border-radius: 50%;
          background:linear-gradient(159deg,rgba(255,255,255,1) 0%,rgba(250,251,254,1) 100%);
          box-shadow:0px 4px 12px 0px rgba(0,0,0,0.1);
        }
        .info-text {
          margin-top: 20px;
          font-size: 12px;
          line-height:20px;
          text-align: center;
        }
      }
    }
    .operation-area {
      text-align: center;
    }
  }

  .ios-skan-guide-modal {
    padding: 0 0 24px 0;
  .content-area {
    background: linear-gradient(0deg, #ECF3FE, #ECF3FE);
    height: 200px;
    width: 100%;
    justify-content: center;
    img {
      width: 526px;
    }
  }
  &.byted-modal {
    .bui-modal-content {
      border-radius: 4px;
      overflow: hidden;
    }
    .bui-modal-dialog {
      width: 600px;
    }
    .bui-modal-header {
      padding: 0
    }
  }
  .explain {
    padding: 24px 24px 0px 24px;
    .explain-title {
      font-weight: 600;
      font-size: 18px;
      line-height: 26px;
      color: #333333;
    }
    .explain-content {
      font-weight: normal;
      font-size: 14px;
      line-height: 22px;
      color: #666666;
      margin-top: 8px;
    }
    .explain-tips {
      color: #999999;
      font-size: 12px;
      line-height: 20px;
      margin-top: 8px;
    }
    .ios-logo-wrapper {
      display: flex;
    }
    .ios-logo {
          color: #338aff;
          padding: 2px 5px;
          background-color: #ebf3ff;
          border-radius: 4px;
          font-size: 12px;
          line-height: 20px;
          font-weight: 600;
          vertical-align: middle;
          margin-right: 4px;
          width: 42px;
        }
        .ios-logo-text {
            display: inline-block;
            line-height: 12px;
            transform: scale(.833333);
            margin-left: 3px;
            margin-top: 2px;;
          }
        .ios-logo-content {
            display: inline-block;
            vertical-align: middle;
        }
  }
  &.venus-modal {
    .venus-modal-footer {
        .venus-button-list {
          text-align: right !important;
          padding-right: 24px
        }
    }
  }
}


  /* Global Style */
  .bui-popover-panel {
    word-break: break-all;
    $popover-panel-padding: 16px;
    .popover-corner-link {
      cursor: pointer;
      position: absolute;
      top: $popover-panel-padding + 12px;
      right: $popover-panel-padding;
    }
  }
  .table-header-popover-body {
    max-width: 212px;
    max-height: 180px; // 从th到页面顶部的最大距离

    a {
      text-decoration: none;
      position: relative;
      .share-icon {
        position: absolute;
        bottom: 2px;
        margin-left: 4px;
      }
    }
  }
  .operation-pop-content {
    max-width: 300px;
    word-break: break-word;
  }
  .table-col-popover {
    max-width: 200px;
    word-break: break-all;
  }
  .suggestion-popover-body {
    min-width: 248px;
    max-width: 400px;
    .byted-loading-v {
      width: 100%;
      height: 36px;
      position: relative;
      display: flex;
      align-items: center;
      background-color: transparent;
      .bui-loading-icon {
        width: 14px;
      }
    }
    .reject-reason-preview-row {
      max-width: 100%;
      word-break: break-all;
    }
  }

  .simulate-dropdown-wrapper {
    margin: -16px;
    min-width: 72px;
    text-align: left;
    border-radius: 4px;
    overflow: auto;
  }
  .byted-select, .byted-input {
    width: auto;
  }
  $icon-color: #666;
  .byted-icon {
    fill: $icon-color;
    cursor: pointer;
  }
  *[disabled] .byted-icon {
    cursor: not-allowed;
  }
  .byted-dropdown-item {
    &.disabled {
      .byted-popover-wrapper {
        display: block;
      }
    }
  }
  .byted-button {
    &.mock-disabled-btn, &.mock-disabled-btn:active {
      color: $disabled-icon-color;
      cursor: not-allowed;
      .byted-icon {
        cursor: not-allowed;
        svg {
          fill: $disabled-icon-color;
        }
      }
    }
  }
  .left-area, .procedural-preview-wrapper {
    .image-background {
      top: 50%;
      transform: translateY(-50%);
      img {
        vertical-align: middle;
        height: auto;
        filter: blur(2.5px);
      }
    }
    .image-content {
      background-color: rgba(0,0,0,.45);
    }
  }
  .creative-preview-wrapper {
    position: relative;
    .image-mode {
      font-size: 10px;
      padding: 0 2px;
    }
  }
  $image-mode-margin: 0;
  .image-mode {
    pointer-events: none;
    position: absolute;
    bottom: $image-mode-margin;
    right: $image-mode-margin;
    white-space: nowrap;
    background: rgba(0, 0, 0, 0.5039);
    border-radius: 6px 0 6px 0;
    font-size:11px;
    font-weight:400;
    color: #fff;
    line-height:16px;
    padding: 0 4px;
  }
  .ad-link {
    cursor: pointer;
  }


  .txt-cut {
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .multiple-line-txt-cut {
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .single-line-txt-cut {
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
  .content-row {
    display: flex;
    align-items: flex-start;
    margin-bottom: 16px;
    word-break: break-all;
    &:last-of-type {
      margin-bottom: 0;
    }
    .label-item {
      max-width: 57px; // 超过四个字折行
      word-break: break-all;
      line-height: 20px;
      margin-top: 6px;
      margin-right: 20px;
    }
    .input-item {
      flex: 1;
      display: flex;
      align-items: center;
    }
  }
  .valid-msg {
    color: #F45858;
  }

  $sm-modal-width: 400px;
  $md-modal-width: 480px;
  .byted-modal .bui-modal-dialog {
    width: $md-modal-width;
  }
  div.delete-modal div.bui-modal-dialog {
    width: $md-modal-width;
  }
  .byted-modal .bui-modal-dialog.bui-modal-sm {
    width: $sm-modal-width;
  }
  .byted-modal {
    font-size: 14px;
  }
  .modify-account-budget-modal {
    .control-label {
      text-align: left;
      padding-left: 0;
    }
    $form-item-width: 200px;
    .byted-radio-group {
      width: $form-item-width;
      button {
        width: 50%;
      }
    }
    .byted-input {
      width: $form-item-width;
    }
  }
  .modify-budget-modal {
    .byted-icon {
      cursor: pointer;
    }
    .budget-input-wrapper {
      display: flex;
      align-items: center;
      .byted-input {
        width: 120px;
        margin: 0 8px;
      }
    }
    .timing-task-wrapper {
      .add-timing-task-btn {
        cursor: pointer;
        color: $link-color;
      }
    }
    .timing-task-block {
      padding: 16px 24px;
      border-radius:4px;
      border:1px dashed #dadfe3;
      .timing-task-header {
        color: #333;
        margin: 0;
        $icon-size: 14px;
        .byted-icon {
          width: $icon-size;
          height: $icon-size;
          float: right;
        }
      }
      .timing-task-content {
        color: #666;
        margin: 16px 0;
        .timing-task-money-val {
          width: 120px;
          color: #333;
          .byted-icon {
            vertical-align: -2px;
          }
        }
        .byted-input {
          display: inline-block;
        }
      }
      .timing-task-mark {
        color: #999;
        font-size: $small-font-size;
      }
    }
  }

  /* Project Style */
  .drawer-outside-wrapper {
    min-height: 100vh;
  }


  .promotion-content-container {
    background-color: #F9F9F9;
    min-width: $page-min-width - $windows-scrollbar-width;
    font-size: $small-font-size;
    font-family: 'PingFangSC-Regular';
    $table-head-padding: 0 16px;

    .byted-popover-wrapper {
      display: block;
    }
    .bui-table-no-data {
      display: none;
    }
    .no-data {
      padding-top: 88px;
      padding-bottom: 135px;
      background: #fff;
      img {
        width: 224px;
      }
      .no-data-tip {
        color: $color-lighter;
      }
    }
    .ad-link {
      line-height: $td-line-height;
      cursor: pointer;
      &.default {
        color: #999;
      }
      &.disabled {
        cursor: not-allowed;
        color: $disabled-color;
        &:hover {
          color: $disabled-color;
        }
        &:active {
          color: $disabled-color;
        }
      }
      &:hover {
        color: #57a5ff;
      }
      &:active {
        color: #1c68d9;
      }
    }

    .promotion-card {
      // overflow: hidden;
      background: #fff;
      box-shadow:0px 1px 6px 0px rgba(0,0,0,0.05);
      /*&.ceiling {
        .promotion-table-filters {
          position: fixed;
          top: 0;
          left: 0;
          overflow: hidden;
          z-index: 2;
          width: 100vw;
          padding-right: 32px;
        }
        margin-top: 50px;
      }*/
    }
    .bui-table-wrapper {
      a {
        color: $link-color;
        text-decoration: none;
        &:visited {
          color: $link-color;
        }
      }
      tr:nth-child(2) th {
        background-color: $th-bg;
      }
      th {
        position: relative;
        padding: 0;
        &:hover {
          cursor: pointer;
          background-color: $th-hover-bg;
        }
        .bui-table-header-icon-wrapper {
          height: 19px;
          position: absolute;
          right: $table-padding;
          top: 50%;
          transform: translateY(-50%);
          padding: 0;
        }
        .table-header {
          width: 100%;
          word-break: break-word;
          padding: 0 $table-padding;
          &.th-sortable {
            padding-right: 16px + $table-padding;
          }
          &:nth-child(2) {
            color: #999
          }
        }
        .default-header-wrapper {
          min-height: $table-header-height;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          width: 100%;
          .byted-popover-wrapper {
            width: 100%;
          }
        }
      }
    }

    .table-content-container {
      position: relative;
      .byted-table .bui-table-wrapper {
        .bui-table-overflow-x {
          overflow-x: hidden;
        }
        &.add-bottom-scrollbar {
          margin-bottom: 15px;
        }
      }
    }
    &.telphone-content {
      .table-content-container .byted-table .bui-table-wrapper .bui-table-overflow-x {
        overflow-x: auto;
      }
    }

    .sticky {
      position: -webkit-sticky;
      position: sticky;
      top:0;
      z-index: 3;
    }
    .promotion-table-filters {
      height: 50px;
      background: #fff;
      padding: 0 16px;
    }

    .promotion-table-filters-left-part {
      .new-btn {
        .byted-icon {
          width: 14px;
          height: 14px;
          margin-right: 4px;
        }
      }
      .control-btns-wrapper {
        margin-left: 48px;
        $control-icon-size: 16px;
        .byted-popover-wrapper {
          margin-left: 20px;
          &:nth-child(1), &:nth-child(3) {
            margin-left: 0;
          }
        }
        .byted-icon {
          width: $control-icon-size;
          height: $control-icon-size;
          vertical-align: top;
        }
        .byted-button {
          position: static;
          min-width: auto;
          font-size: 12px;
          font-family:PingFangSC-Regular;
          font-weight:400;
          line-height:20px;
          border: none;
          background: transparent;
          padding: 0;
          display: flex;
          align-items: center;
          .byted-icon {
            margin-right: 4px;
          }
          &.no-text-button {
            .byted-icon {
              width: $control-icon-size;
              height: $control-icon-size;
              margin-right: 0;
            }
          }
          &[disabled], &.mock-disabled-btn {
            color: $disabled-icon-color;
            cursor: not-allowed;
            .byted-icon {
              cursor: not-allowed;
              svg {
                fill: $disabled-icon-color;
              }
            }
          }
        }
      }
      .local-filter {
        display: flex;
        align-items: center;
        font-size: $small-font-size;
        font-weight: 400;
        color: #fff;
        height: $basic-height;
        line-height:$basic-height;
        background-color: #384F6E;
        padding: 0 14px;
        border-radius:15px;
        margin-left: 24px;
        .bui-icon-delete-circle {
          width: 14px;
          height: 14px;
          margin-left: 8px;
        }
      }
    }

    .promotion-table-wrapper {
      position: relative;
      &.is-loading {
        min-height: 600px; // 10行的最小宽度
      }
    }

    $control-col-padding: 16px;
    .promotion-ad, .promotion-campaign, .promotion-keyword {
      .promotion-table, .bui-table-wrapper {
        .bui-table-fixed-left .bui-table-fixed-header {
          thead tr:first-child th {
            .byted-checkbox{
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
          thead tr:nth-child(2){
            th:not(:last-child){
              border-right: none;
              .byted-checkbox{
                display: none;
              }
            }
          }
        }
        table {
          th {
            &:first-child {
              border-right: none;
            }
            &:first-child, &:nth-child(2) {
              cursor: default;
              &:hover {
                background-color: $th-bg;
              }
            }
          }
        }
        .bui-table-tr {
          .bui-table-column {
            &:nth-child(1) {
              padding: 0 $control-col-padding;
              border-right: none;
            }
            &:nth-child(2) {
              padding: 0 $control-col-padding 0 0;
            }
          }
        }
      }
    }
    .promotion-creative {
      .bui-table-tr {
        .bui-table-column {
          &:nth-child(1) {
            padding: 0 $control-col-padding;
          }
        }
      }
    }

    .promotion-table {
      .bui-table-wrapper {
        width: 100%;
        th {
          .bui-table-ceil {
            font-size: $small-font-size;
            font-family: 'PingFangSC-Medium';
            font-weight: 500;
            color: $color;
            padding: 0;
          }
          &.no-right-border {
            border-right-color: transparent;
          }
        }
        .bui-table-column {
          display: inline-flex;
          align-items: center;
          padding: $table-padding/2 $table-padding;
          $md-icon-size: 14px;
          .byted-icon {
            width: $md-icon-size;
            height: $md-icon-size;
          }
          .bui-table-ceil {
            width: 100%;
            font-size: $small-font-size;
            font-weight: 400;
            color: $color;
            & > div {
              width: 100%;
            }
          }
          .table-data-img-icon {
            vertical-align: middle;
            cursor: pointer;
          }
          &:first-child {
            .byted-switch {
              display: block;
            }
          }
        }
        .cell {
          &-with-icon-left {
            position: relative;
            display: flex;
            height: 100%;
            align-items: center;
            justify-content: flex-end;
            .byted-icon {
              display: none;
              margin-right: 8px;
              min-width: 14px;
              &:hover {
                fill: $link-color;
              }
            }
            &-active, &:hover {
              .byted-icon {
                display: block;
              }
            }
            .have_timed_task {
              fill: $link-color;
              display: block;
            }
          }
          &-with-icon {
            height: 100%;
            display: flex;
            align-items: center;
            $icon-size: 14px;
            .table-cell-reference-wrapper {
              min-width: $icon-size;
              margin-left: 8px;
              .byted-icon {
                display: none;
              }
            }
            .byted-icon {
              cursor: pointer;
              width: $icon-size;
              height: $icon-size;
              vertical-align: middle;
              &:hover {
                fill: $link-color;
              }
            }
            &-active, &:hover {
              .table-cell-reference-wrapper {
                .byted-icon {
                  display: inline-block;
                }
              }
            }
          }
        }
        .cell-sub-content {
          color: #999;
        }
        .cell-content-link {
          display: block;
          max-width: 100%;
        }

        .bui-table-ceil {
          $label-size: 6px;
          .status-text-wrapper {
            height: $td-line-height;
            line-height: $td-line-height;
            display: flex;
            align-items: center;
          }
          .status-process {
            margin-left: 10px;
          }

          // 消耗-搜索消耗-绿色标签
          .tag-search-ad-cost {
            display: inline-block;
            padding: 0 4px;
            font-size: 12px;
            color: #6ABF40;
            background: #F3FAF0;
            border-radius: 4px;
            cursor: pointer;
            transform-origin: right;
            transform: scale(0.9);
          }

          .keyword-quality-text-wrapper {
            .keyword-quality-rate {
              margin-right: 5px;
              /deep/ .bui-rate-wrapper .bui-rate-item {
                fill: #FFA900;
                .bui-rate-item-half {
                  width: 5.5px;
                }
                .bui-rate-icon-fill {
                  fill: #FFA900;
                }
                .byted-icon {
                  font-size: 11px;
                  padding-right: 4px;
                  width: 11px;
                  height: 11px;
                }
              }
            }
          }

          .cell-status-label {
            width: $label-size;
            height: $label-size;
            min-width: $label-size;
            border-radius: 50%;
            background-color: #999;
            display: inline-block;
            vertical-align: middle;
            margin-right: 4px;
            &.active {
              background-color: #66C23A;
            }
          }
          $status-icon-size: 27px;
          .badges-wrapper {
            width: $status-icon-size;
            height: $status-icon-size;
            min-width: $status-icon-size;
            line-height: $status-icon-size;
            margin-left: 4px;
            .byted-popover-wrapper, img {
              width: 100%;
              height: 100%;
              cursor: pointer;
            }
            &_safeguard {
              margin-left: 2px;
            }
            &_safeguard-and—study {
              width: 27px;
            }
          }
        }
        .operation-wrapper {
          .bui-btn-text {
            padding: 0;
            min-width: auto;
          }
          .bui-icon-more {
            display: block;
          }
        }
      }

      .more-operations-wrapper {
        display: inline-block;
        position: relative;
        &:hover {
          .more-operations {
            display: block;
          }
        }
        .byted-icon {
          cursor: pointer;
        }
        .more-operations {
          display: none;
          position: absolute;
          top: 100%;
          right: 0;
          z-index: 1;
          background-color: #fff;
          border: 1px solid #ddd;
          .more-operation {
            word-break: keep-all;
            cursor: pointer;
            color: $color;
            padding: 0 12px;
            &:hover {
              background-color: #aaa;
            }
          }
        }
      }

      //$selected-bg: #E4E9ED;
      $hover-bg: #F8F9FA;
      .bui-table-tr {
        &.selected-row {
          background-color: $hover-bg;
        }
      }
    }

    .promotion-footer {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .page-size-select {
        width: 90px;
      }
      .pagination-wrapper {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin: 16px 24px 24px;
      }
    }

    .cell-creative-image {
      display: flex;
      align-items: center;
      .creative-title {
        line-height: 20px;
        margin-left: 8px;
      }
    }
  }
  // table 顶部自定义列icon
  .reset-columns_button, .custom-columns_button {
    display: flex;
    align-items: center;
  }
  // 组，计划，账户 -- 定时任务与 预算
  .time-task {
    font-size: 12px;
    color: #2F88FF;
  }
  .time-task-delate {
    color: #F45858!important;
    margin-left: 10px;
  }

  .col-auto-size-text-wrapper {
    min-width: 0;
  }
  .status.txt-cut {
    min-width: 20px;
  }

  html {
    &:lang(en) {
      .filter-panel .all-filters-wrapper .sub-filters-content-wrapper .sub-filters-group-wrapper .sub-filters .sub-filter-name {
        width: 110px;
      }
      .modify-account-budget-modal .byted-radio-group {
        width: 290px;
      }
      .dialog-customized-column .customized-column-content .column-area .column-select-panel .column-group .column-items .column-item .byted-checkbox {
        label {
          display: flex;
          .bui-checkbox-input-wrapper {
            min-width: 14px;
          }
        }
      }
      .weektime-modal .bui-modal-dialog {
        width: 925px;
        .calendar-table {
          width: 100%;
        }
      }
      .suggestion-popover-body {
        min-width: 288px;
      }
      .content-row .label-item {
        word-break: keep-all;
      }
      .promotion-content-container .promotion-table .bui-table-wrapper .bui-table-column .bui-table-ceil {
        word-break: keep-all;
      }
      .promotion-content-container .promotion-table .bui-table-wrapper .bui-table-ceil .cell-status-label {
        min-width: 6px;
      }
    }
    &:lang(ja) {
      .campaign-drill-dropdown {
        .byted-dropdown-menu-wrapper {
          width: 140px;
        }
      }
      .promotion_autorules_dropdown {
        width: 100px;
      }
      .modify-account-budget-modal .byted-radio-group {
        width: 220px;
      }
      .filter-panel .all-filters-wrapper {
        .btn-filter-all {
          width: auto;
        }
        .sub-filters-nav-wrapper {
          width: 162px;
        }
        .sub-filters-content-wrapper .sub-filters-group-wrapper .sub-filters .sub-filter-name {
          width: 125px;
        }
      }
      .dialog-customized-column .customized-column-content .column-area .column-select-panel .column-group .column-items .column-item .byted-checkbox {
        label {
          display: flex;
        }
      }
      .promotion-content-container .promotion-table-filters-left-part .local-filter {
        .txt-cut {
          max-width: 100px;
        }
      }
      .pop-edit .input-area {
        width: 100px;
      }
    }
  }
  // 推广管理吸顶表格的会覆盖 notification ，修改 z-index > 推广管理吸顶表格的 z-index
  .byted-notification-topRight {
    z-index: 997;
  }
  // 由于计划下的 selection 列，有拖拽会影响下来操作，将其隐藏
  .promotion-ad .bui-table-fixed-left .bui-table-fixed-header table thead tr th:first-child .bui-table-th-resize {
    display: none;
  }

</style>
